import { __assign } from "tslib";
import { TableRow, styled } from '@mui/material';
import { alpha } from "@mui/system";
var statusMixin = function (_a) {
    var theme = _a.theme, status = _a.status;
    return (__assign(__assign({}, (status === 'warning' && {
        backgroundColor: alpha(theme.palette.warning[100], 0.24),
        '&&:hover': {
            backgroundColor: alpha(theme.palette.warning[100], 0.36),
        }
    })), (status === 'error' && {
        backgroundColor: alpha(theme.palette.error[100], 0.24),
        '&&:hover': {
            backgroundColor: alpha(theme.palette.error[100], 0.36),
        }
    })));
};
export var StyledTableRow = styled(TableRow, {
    shouldForwardProp: function (prop) { return !['checked', 'status'].includes(String(prop)); },
})(function (_a) {
    var theme = _a.theme, checked = _a.checked, status = _a.status;
    return (__assign(__assign({}, (checked && {
        backgroundColor: alpha(theme.palette.greySecondary.A100, 0.24),
        '&&:hover': {
            backgroundColor: alpha(theme.palette.greySecondary.A100, 0.36),
        }
    })), (status && statusMixin({ theme: theme, status: status }))));
});
//# sourceMappingURL=styled.js.map